export const EXECUTIVE_CUSTOM_PERIOD_ID = 'custom'

export const EXECUTIVE_PERIOD_OPTIONS = [
  { id: '1m', label: '1M' },
  { id: '3m', label: '3M' },
  { id: '6m', label: '6M' },
  { id: 'ytd', label: 'YTD' },
  { id: EXECUTIVE_CUSTOM_PERIOD_ID, label: 'Custom' },
]

const toDateInputValue = (date) => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export const getDefaultExecutiveCustomDateRange = () => {
  const end = new Date()
  const start = new Date(end)
  start.setDate(end.getDate() - 29)
  return {
    start: toDateInputValue(start),
    end: toDateInputValue(end),
  }
}

export const getExecutiveCustomPeriodDayCount = (range) => {
  if (!range?.start || !range?.end) return 30
  const start = new Date(range.start)
  const end = new Date(range.end)
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || end < start) return 30
  return Math.round((end.getTime() - start.getTime()) / (24 * 60 * 60 * 1000)) + 1
}

export const formatExecutiveCustomDateRangeLabel = (range) => {
  if (!range?.start || !range?.end) return 'Custom range'
  const start = new Date(range.start)
  const end = new Date(range.end)
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return 'Custom range'
  const opts = { month: 'short', day: 'numeric', year: 'numeric' }
  return `${start.toLocaleDateString('en-US', opts)} – ${end.toLocaleDateString('en-US', opts)}`
}

export const resolveExecutivePeriodScale = (period, customDateRange) => {
  if (period !== EXECUTIVE_CUSTOM_PERIOD_ID) {
    const scales = { '1m': 1, '3m': 1.28, '6m': 1.62, ytd: 1.95 }
    return scales[period] || 1
  }

  const days = getExecutiveCustomPeriodDayCount(customDateRange)
  if (days <= 31) return 1
  if (days <= 95) return 1.28
  if (days <= 185) return 1.62
  return 1.95
}

export const resolveExecutiveTrendPeriod = (period, customDateRange) => {
  if (period !== EXECUTIVE_CUSTOM_PERIOD_ID) return period

  const days = getExecutiveCustomPeriodDayCount(customDateRange)
  if (days <= 31) return '1m'
  if (days <= 95) return '3m'
  if (days <= 185) return '6m'
  return 'ytd'
}

export const isExecutiveCustomPeriod = (period) => period === EXECUTIVE_CUSTOM_PERIOD_ID
